export const removeDecimals = (number: number) => Number(number.toFixed(0));

export const numberToPercentage = (
  numberToConvert?: number,
  total?: number,
) => {
  if (!numberToConvert || !total) return 'N/A';
  return removeDecimals((numberToConvert / total) * 100);
};
